import {
  constFunction,
  ListType,
  Node,
  opArtifactAliasAlias,
  opArtifactId,
  opArtifactIsPortfolio,
  opArtifactMembershipArtifactAliases,
  opArtifactMembershipArtifactVersion,
  opArtifactMembershipVersionIndex,
  opArtifactName,
  opArtifactProject,
  opArtifactVersionCreatedAt,
  opArtifactVersionId,
  opArtifactVersionMetadata,
  opArtifactVersionRawTags,
  opArtifactVersionSize,
  opArtifactVersionUsedBy,
  opCount,
  opDict,
  opEntityName,
  opMap,
  opNumberToByteString,
  opProjectEntity,
  opProjectName,
  OutputNode,
} from '@wandb/weave/core';

export function dataDictNode(
  artifactNode: Node<'artifact'>,
  artifactMembershipsNode: OutputNode<ListType<'artifactMembership'>>
) {
  return opDict({
    collectionMemberships: opMap({
      arr: artifactMembershipsNode,
      mapFn: constFunction({row: 'artifactMembership'}, ({row}) => {
        return opDict({
          versionIndex: opArtifactMembershipVersionIndex({
            artifactMembership: row,
          }),
          versionId: opArtifactVersionId({
            artifactVersion: opArtifactMembershipArtifactVersion({
              artifactMembership: row,
            }),
          }),
          aliases: opArtifactAliasAlias({
            artifactAlias: opArtifactMembershipArtifactAliases({
              artifactMembership: row,
            }),
          }),
          tags: opArtifactVersionRawTags({
            artifactVersion: opArtifactMembershipArtifactVersion({
              artifactMembership: row,
            }),
          }),
          metadata: opArtifactVersionMetadata({
            artifactVersion: opArtifactMembershipArtifactVersion({
              artifactMembership: row,
            }),
          }),
          created: opArtifactVersionCreatedAt({
            artifactVersion: opArtifactMembershipArtifactVersion({
              artifactMembership: row,
            }),
          }),
          consumingRuns: opCount({
            arr: opArtifactVersionUsedBy({
              artifactVersion: opArtifactMembershipArtifactVersion({
                artifactMembership: row,
              }),
            }),
          }),
          size: opNumberToByteString({
            in: opArtifactVersionSize({
              artifactVersion: opArtifactMembershipArtifactVersion({
                artifactMembership: row,
              }),
            }),
          }),
        } as any) as any;
      }),
    }),
    collectionName: opArtifactName({artifact: artifactNode}),
    collectionId: opArtifactId({artifact: artifactNode}),
    collectionIsPortfolio: opArtifactIsPortfolio({
      artifact: artifactNode,
    }),
    entityName: opEntityName({
      entity: opProjectEntity({
        project: opArtifactProject({
          artifact: artifactNode,
        }),
      }),
    }),
    projectName: opProjectName({
      project: opArtifactProject({
        artifact: artifactNode,
      }),
    }),
  } as any) as unknown as OutputNode<{
    type: 'typedDict';
    propertyTypes: {
      collectionMemberships: {
        type: 'list';
        objectType: {
          type: 'typedDict';
          propertyTypes: {
            versionIndex: 'number';
            versionId: 'string';
            aliases: {type: 'list'; objectType: 'string'};
            tags: {type: 'list'; objectType: 'any'};
            metadata: 'any';
            // loggedBy: 'string';
            created: 'string';
            consumingRuns: 'number';
            size: 'string';
          };
        };
      };
      collectionName: 'string';
      collectionId: 'string';
      collectionIsPortfolio: 'boolean';
      entityName: 'string';
      projectName: 'string';
    };
  }>;
}

// helper function to sort aliases so that protected aliases are first
// and both protected and normal aliases are ordered alphabetically
export function sortAliases(
  alias1: {name: string; isProtectedAlias: boolean},
  alias2: {name: string; isProtectedAlias: boolean}
) {
  if (alias1.isProtectedAlias === alias2.isProtectedAlias) {
    return alias1.name.localeCompare(alias2.name);
  }
  return alias1.isProtectedAlias ? -1 : 1;
}
